import { UUID } from '@/plugins/common'
import _ from 'lodash'

export default class Condition {
  id = ''
  fieldId = ''
  nodeId=''
  operator = ''
  value = ''
  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    args.id = UUID.create()
    let condition = new Condition(args)
    return condition
  }

  static load (args) {
    let condition = new Condition(args)
    return condition
  }
}



// WEBPACK FOOTER //
// ./src/store/process/condition.js